import React, { useState, useEffect } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';

import { Create, Add, DirectionsWalkSharp, DirectionsWalkRounded } from '@material-ui/icons';

import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

import { wsGetAll } from 'services/WService.js';

import ModalDistributionStaff from './Modal';
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { WithApp } from 'contexts/appContext';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
});

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 140 },
  { Header: 'Código', accessor: 'code', width: 130 },
  { Header: 'Nombre completo', accessor: 'name' },
  { Header: 'Nombres', accessor: 'FirstName' },
  { Header: 'Apellidos', accessor: 'LastName' },
  { Header: 'Telefono', accessor: 'phone' },
  { Header: 'Lic. conducir', accessor: 'driver_license' },
  { Header: '', accessor: 'actions', width: 0 }
];

export default WithApp(function DistributionStaff(props) {
  const classes = useStyles();
  const [model, setOpen] = useModal();
  const [notify, showNotify] = useToasty();
  const [distributionStaffs, setDistributionStaff] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);

  async function loadEmployeeStatus() {
    setDataLoading(true);
    let response = await wsGetAll('prog/public-distribution-staff');
    setDataLoading(false);
    if (response.success) setDistributionStaff(response.data);
  }

  useEffect(() => {
    loadEmployeeStatus();
  }, []);

  return (
    <GridContainer>
      <Toasty action={notify} />
      <ModalDistributionStaff
        model={model}
        setOpen={setOpen}
        showNotify={showNotify}
        reload={loadEmployeeStatus}
      />
      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <AllowedGuard
              permission={ConstantPermissions.PROG_DISTRIBUTION_STAFF_STORE}
              component={
                <CardIcon color="primary">
                  <DirectionsWalkRounded style={{ color: 'white' }} />
                </CardIcon>
              }
            >
              <CardIcon
                onClick={() => setOpen({})}
                pointer="true"
                color={props.themeContext.buttonColorSuccess}
              >
                <Add />
              </CardIcon>
            </AllowedGuard>
            <h4 className={classes.cardIconTitle}>Listado de choferes publicos {dataLoading && <LoadingSpinner />}</h4>
          </CardHeader>
          <CardBody>
            <ReactTable
              excelName="Choferes_publicos"
              defaultWidth={1500}
              columns={columns}
              data={distributionStaffs.map((item, i) => {
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <AllowedGuard permission={ConstantPermissions.PROG_DISTRIBUTION_STAFF_UPDATE}>
                        <Button
                          justIcon
                          round
                          simple
                          color="info"
                          className="like"
                          onClick={() => setOpen(item)}
                        >
                          <Create />
                        </Button>
                      </AllowedGuard>
                      <AllowedGuard
                        permission={ConstantPermissions.PROG_DISTRIBUTION_STAFF_DELETED}
                      >
                        <ButtonDelete
                          entity="prog/public-distribution-staff"
                          id={item.id}
                          reload={loadEmployeeStatus}
                        />
                      </AllowedGuard>
                    </div>
                  ),
                  code: item.code,
                  name: item.name,
                  FirstName: item.FirstName,
                  LastName: item.LastName,
                  phone: item.phone,
                  driver_license: item.driver_license,
                  actions: ''
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
